<template>
    <div class="gfk-header shadow-1">
        <div class="row reverse gfk-header__top" >
            <div class="col-auto">
                <slot name="right-top"/>            
            </div>
        </div>

        <div class="row items-center">
            <div class="col-auto">
                <div class="row flex-center">
                    <div class="col-auto gfk-header__gfk-logo">
                        <slot name="gfk-logo">
                            <img src="../../static/gfk-logo.jpg" alt="GfK" width="50" height="50"/>
                        </slot>
                    </div>
                    <div class="col-auto">
                        <h1 class="gfk-header__title gfk_logo_title">
                            <slot name="title">
                                {{ title }}
                            </slot>
                        </h1>
                        <h2 class="gfk-header__subtitle gfk_logo_subtitle">
                            <slot name="subtitle">
                                {{ subtitle }}
                            </slot>
                        </h2>
                    </div>
                </div>
            </div>

            <div class="col-xl-2 col-md-3 col-xm-12 gfk-header__context-switcher" v-if="$slots['context-switcher']">
                <slot name="context-switcher"/>
            </div>

            <div class="IDnavigation col-auto gfk-header__navigation xs-hide" v-if="$slots.navigations">
                <slot name="navigation"/>
            </div>
            
            <div class="col-auto gfk-header__bottom-right xs-hide">
                <div class="gfk-header__customer-logo">
                    <slot name="customer-logo"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
	export default {
		name: 'gfk-header',
		props: {
			title: {
				type: String
			},
			subtitle: {
				type: String
			}
		}
	};
</script>
